import config from '../config';

export default function reportPackages(packagesIds) {
    return fetch(`${config.cache.apiBaseURL}/packages`, {
        body: JSON.stringify({ packagesIds }),
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
    });
}